import React from "react";
import { Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import "./Header.css";


const Header = () => {
  return (
      <div className="App">
        <div className="App-header">
          <Container fluid className="pt-3 custom-minwidth">
            <div className='App-header-name'>
              <h2 className=''>Janssen Prize for <br/> Creativity in Organic Synthesis</h2>
            </div>
            <nav className="navbar navbar-expand-lg navbar-light">
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
              <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav">
                  <li className="nav-item me-2">
                    <NavLink className="nav-link" to="/">Home</NavLink>
                  </li>
                  <li className="nav-item me-2">
                    <NavLink className="nav-link" to="/history">History</NavLink>
                  </li>
                  <li className="nav-item me-2">
                    <NavLink className="nav-link" to="/winners">Winners</NavLink>
                  </li>
                  <li className="nav-item me-2">
                    <NavLink className="nav-link" to="/jury">Jury</NavLink>
                  </li>
                  <li className="nav-item me-2">
                    <NavLink className="nav-link" to="/nominations">Nominations</NavLink>
                  </li>
                  <li className="nav-item me-2">
                    <NavLink className="nav-link" to="/media">Media</NavLink>
                  </li>
                  <li className="nav-item me-2">
                    <NavLink className="nav-link" to="/contact">Contact</NavLink>
                  </li>
                </ul>
              </div>
            </nav>

          </Container>
        </div>
      </div>
  );
}

export default Header;